import React, { useEffect } from "react";

export const usePrism = (
  containerRef: React.RefObject<HTMLElement>,
  trigger: boolean
) => {
  const api = window.__rendering!.prism!;

  // Load library on mount.
  useEffect(() => {
    api.load();
  }, []);

  // Re-render when state or content changes.
  useEffect(() => {
    if (!api.ready || !containerRef.current || !trigger) return;
    api.render(containerRef.current);
  }, [trigger, api.ready]);

  // Watch for new content, render that where necessary
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof HTMLElement) api.render(node);
        }
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, [api.ready]);
};
